import { DOC_ERROR_TYPE, SELFIE_ERROR_TYPE } from '../../tagging/index.js';
import { NONE_OPTION_SELECTED, PASSPORT, UK_DRIVING_LICENCE, } from '../../utils/constants.js';
export default {
    general: {
        header: {
            link: 'https://www.lloydsbank.com/business/home.html',
        },
        headerNavigation: {
            adminPanel: 'Financials',
            manufacturers: 'Exclusions',
            mi: 'MI',
            auditTrail: 'Audit trail',
            logout: 'Logout',
            eligibility: 'Eligibility',
        },
    },
    containers: {
        proofOfIdentity: {
            applicationHeading: 'Business Account application',
            pageTitle: 'Proof of identity',
        },
        takePhotoContent: {
            applicationHeading: 'Business Account application',
            pageTitlePassport: 'Take a photo of your passport',
            pageTitleDL: 'Take a photo of your driving licence',
        },
        allowPermission: {
            applicationHeading: 'Business Account application',
            pageTitle: 'We can’t access the camera',
        },
        capturePhoto: {
            applicationHeading: 'Business Account application',
            pageTitle: 'Is this a good quality photo?',
        },
        takeSelfieContent: {
            applicationHeading: 'Business Account application',
            pageTitle: 'Take a photo of your face',
        },
        barcode: {
            applicationHeading: 'Business Account application',
            pageTitle: 'Switch to a smartphone or tablet to confirm your identity',
        },
        applicationStatusContainer: {
            common: {
                heading: 'Your Business Account Application',
                needHelpBox: {
                    heading: 'Need help?',
                    descriptionOne: 'Our customer support team is ready to help. Quote your reference number:',
                    callUs: {
                        label: 'Call us on:',
                        number: '0345 835 7410',
                    },
                    descriptionTwo: 'Lines are open 9am - 5pm Monday to Friday',
                },
            },
        },
    },
    components: {
        loadingOverlay: {
            title: 'Loading...',
        },
        proofOfIdentity: {
            description: {
                one: 'To confirm your identity, we compare a photo of your ID with a photo you take of your face.',
                two: 'We store the photo of your ID securely. We don’t store the photo of your face or any data about your face (sometimes known as biometric data).',
                three: 'You can find out more about how we use your personal data in our ',
                link: 'privacy policy.',
            },
            navigation: {
                submitLabel: 'Continue',
                previousLabel: 'Previous',
                businessPrivacyLink: 'https://www.lloydsbank.com/business/privacy.html',
            },
            options: [
                {
                    value: PASSPORT,
                    name: 'passport',
                    taggingLabel: 'Photo ID:',
                    id: '1',
                    label: 'Passport',
                    checked: false,
                },
                {
                    value: UK_DRIVING_LICENCE,
                    name: 'uk_driving_licence',
                    taggingLabel: 'Photo ID:',
                    id: '2',
                    label: 'UK driving licence',
                    checked: false,
                },
                {
                    value: NONE_OPTION_SELECTED,
                    name: 'either_option',
                    taggingLabel: 'Photo ID:',
                    id: '3',
                    label: 'I don’t have either of these',
                    checked: false,
                },
            ],
            notification: {
                spinnerTitle: 'Please wait...',
                passport: 'We can only accept passports that are in date.',
                drivingLicense: 'Your driving licence must be in date and show your current home address.',
                warning: {
                    heading: 'We need to confirm your identity in one of our branches',
                    desc1: 'Because we can’t check your passport or driving licence online, we need to confirm your identity in person.',
                    desc2: 'Once you’ve submitted your application, we’ll send you an email that explains everything.',
                },
                warningForPost: {
                    heading: 'Confirm your identity by post',
                    desc1: 'We can’t confirm your identity online without a biometric check',
                    descriptionLink: 'Find out how to register by post',
                },
            },
            notificationEitherOption: {
                warning: {
                    heading: 'We need to confirm your identity in one of our branches',
                    desc1: 'Because we can’t check your passport or driving licence online, we need to confirm your identity in person.',
                    desc2: 'Once you’ve submitted your application, we’ll send you an email that explains everything.',
                },
            },
            dropDownLabel: 'Country of issue',
            formValidation: {
                requiredField: 'Please select country',
                requiredOptionField: 'Please select an Option',
            },
            toggleButton: 'Do you agree to this biometric check?',
            toggleButtonPost: 'Are you happy for us to verify you using biometric checks?',
            toggleButtonSupportiveText: "If you say 'no', we'll need to confirm your identity in one of our branches. This will delay your application.",
            toggleButtonSupportiveTextPost: 'If you don’t want to confirm your identity using your passport or UK driving licence, you can register by post instead.',
            toggleButtonSelectorOptions: [
                {
                    id: 'bio-metric-status-yes',
                    name: 'bio-metric-status',
                    value: 'Yes',
                    label: 'Yes',
                },
                {
                    id: 'bio-metric-status-no',
                    name: 'bio-metric-status',
                    value: 'No',
                    label: 'No',
                },
            ],
        },
        takePhotoContent: {
            passport: {
                desc: [
                    'Open your passport on the photo page and lay it on a well-lit flat surface',
                    'Select ‘Take photo’ and allow Lloyds Bank to access your camera',
                    'Put the white box over your ID and adjust your phone until the box goes green',
                    'Hold still and the picture will be taken automatically. ',
                ],
            },
            dl: {
                desc: [
                    'Put your driving licence on a well-lit flat surface with the photo facing towards you',
                    'Select ‘Take photo’ and allow Lloyds Bank to access your camera',
                    'Put the white box over your ID and adjust your phone until the box goes green',
                    'Hold still and the picture will be taken automatically.',
                ],
            },
            example: 'Examples:',
            goodPhoto: 'Good photo',
            badPhoto: 'Bad photo',
            navigation: {
                submitLabel: 'Take photo',
                previousLabel: 'Previous',
            },
        },
        takeSelfieContentForm: {
            selfie: {
                desc: [
                    'Stand against a plain background in a well-lit area and remove any hats, scarves or glasses',
                    'Select `Take photo`',
                    'Hold your phone in front of you, place your face within the white frame and look straight ahead',
                    'Adjust your phone until the frame goes green',
                    'Hold still and the picture will be taken automatically.',
                ],
            },
            example: 'Examples:',
            goodPhoto: 'Good photo',
            badPhoto: 'Bad photo',
            navigation: {
                submitLabel: 'Take photo',
                previousLabel: 'Previous',
            },
        },
        countryList: [
            {
                label: 'Please select an Option',
                value: 'Please select an Option',
                disabled: true,
            },
            'United Kingdom',
            'Australia',
            'Austria',
            'Belgium',
            'Bulgaria',
            'Canada',
            'Croatia',
            'Czech Republic',
            'Denmark',
            'Estonia',
            'Finland',
            'France',
            'Germany',
            'Greece',
            'Guernsey',
            'Hong Kong',
            'Hungary',
            'Iceland',
            'Ireland',
            'Isle of Man',
            'Italy',
            'Japan',
            'Jarsey',
            'Latvia',
            'Liechtenstein',
            'Lithuania',
            'Luxembourg',
            'Netherlands',
            'New Zealand',
            'Norway',
            'Poland',
            'Portugal',
            'Republic of Cyprus',
            'Romania',
            'Singapore',
            'Slovakia',
            'Slovenia',
            'Spain',
            'Sweden',
            'Switzerland',
            'USA',
        ],
        barCode: {
            title: 'Make things easier by switching to a mobile phone or tablet',
            paragraph: {
                one: 'To confirm your identity, we need you to take a photo of your ID and face using a smartphone or tablet. For example: an iPhone, iPad, Samsung Galaxy, or Samsung Galaxy Pad.',
                three: "You can switch back to your computer once you've finished this step.",
                four: 'If you’d rather stay on your computer, we’ll ask you to upload certified ID.',
            },
            switchLabel: 'How to switch to a smartphone or tablet',
            switchSupportiveText: 'Scan the QR code from the device you’re going to use and log on to your application.',
            navigation: {
                next: 'Stay on computer',
            },
            cantSwitch: {
                title: 'If you can’t switch to a smartphone or tablet...',
                paragraph: {
                    one: 'We’ll need to check your ID in one of our branches. After you submit your application, we’ll send you an email explaining how it works.',
                },
            },
        },
        allowPermissionForm: {
            steps: [
                'Go to your browser’s settings',
                'Look for privacy and security options',
                'Look for site settings',
                'Look for camera permissions',
                'Remove our site [xxxx] from the list of blocked sites.',
            ],
            description: {
                notCompatible: 'The browser you are using may not be compatible, make sure it is up to date or try a different browser.',
                skip: 'If this is still not working you can ‘Skip’ this part but we’ll need to see certified ID before we can process it. We’ll tell you more about this after you’ve submitted your application.',
            },
            navigation: {
                next: 'Try again',
                previous: 'Skip',
            },
        },
        capturePhotoForm: {
            navigation: {
                next: 'Continue',
                previous: 'Retake photo',
            },
            confirmation: {
                heading: 'I confirm that:',
                points: {
                    pointOne: 'the details on my ID are easy to read',
                    pointTwo: 'the image of my face is clear',
                    pointThree: 'all four corners of my ID are visible',
                    pointFour: 'my ID is the only thing in shot',
                    pointFive: 'my thumb or finger is not covering the camera.',
                },
                error: 'Please confirm to continue',
            },
        },
        selfiePhotoForm: {
            navigation: {
                next: 'Continue',
                previous: 'Retake photo',
            },
            confirmation: {
                heading: 'I confirm that this is a good quality photo and the image of my face is clear',
                error: 'Please confirm to continue',
            },
        },
        technicalError: {
            heading: 'Sorry, there’s a technical problem',
            message: 'We can’t accept this photo right now because we’re having technical issues.',
            tryAgain: 'Please try again.',
        },
        retakeScreen: {
            heading: 'Please try again',
            message: 'Unfortunately, we can’t accept one or both of the photos you’ve just taken.',
            note: 'It might be because:',
            points: [
                'the image quality isn’t good enough',
                'there’s too much or not enough light in the background',
                'you’re not using a document we accept',
                'we can’t get the information we need from your photos',
            ],
        },
        scanDocumentForm: {
            notification: {
                spinnerTitle: 'Please wait...',
            },
            navigation: {
                autoCaptureButton: 'Auto capture',
            },
        },
        selfieDocumentForm: {
            notification: {
                spinnerTitle: 'Please wait...',
            },
            navigation: {
                autoCaptureButton: 'Auto capture',
            },
        },
    },
    sectionStartEndContainers: {
        stepFour: {
            applicationHeading: 'Business Account application',
            step: 'Step 3 of 4',
            multiKapStep: 'Step 4 of 5',
            heading: 'Your ID and documents',
            imageAltName: 'your-agreement-doc-image',
            submit: 'Continue',
            previous: 'Previous',
            finishStep: 'All steps completed',
            finishHeading: 'We now need to check the information you’ve provided',
        },
    },
    errorContainers: {
        timeoutError: {
            dialogTitle: 'You’re about to be logged off',
            dialogText: 'We’ll save your application so you can come back to it later.',
            buttons: {
                logIn: 'Stay logged on',
                logout: 'Log off now',
            },
        },
        serverError: {
            errorTitle: 'Sorry, there’s been a technical problem',
            errorText: 'Please try again or close your browser and come back later.',
            buttons: {
                tryAgain: 'Try again',
                close: 'Close',
            },
        },
    },
    navigation: {
        backButtonText: 'Previous',
        nextButtonText: 'Continue',
        saveButtonText: 'Save',
        saveBusinessButtonText: 'Save business',
        cancelButtonText: 'Cancel',
        saveAssetButtonText: 'Save asset',
        saveDirectorButtonText: 'Save person',
        saveQuoteButtonText: 'Save quote',
        saveAndContinueButtonText: 'Save and Continue',
        takePhoto: 'Take photo',
    },
    actions: {
        update: 'Update',
        reset: 'Reset',
        downloadReport: 'Download report',
        resetDates: 'Reset Dates',
        cancel: 'Cancel',
        save: 'Save',
        selectAll: 'Select All',
    },
    footer: {
        security: {
            text: 'Security',
            link: 'https://www.lloydsbank.com/business/security.html',
        },
        legal: {
            text: 'Legal',
            link: 'https://www.lloydsbank.com/business/legal.html',
        },
        privacy: {
            text: 'Privacy',
            link: 'https://www.lloydsbank.com/business/privacy.html',
        },
        cookies: {
            text: 'Cookies',
            link: 'https://www.lloydsbank.com/cookies.html',
        },
        accessibility: {
            text: 'Accessibility',
            link: 'https://www.lloydsbank.com/help-guidance/accessibility.html',
        },
        sitemap: {
            text: 'Sitemap',
            link: 'https://www.lloydsbank.com/business/site-map.html',
        },
    },
    importantInfo: {
        copyright: '© Copyright Lloyds Bank Commercial Finance 2020',
        registeredOffice: {
            lloydsBanking: 'Lloyds Bank plc, Registered Office: 25 Gresham Street, London EC2V 7HN. Registered in England & Wales no. 2065. Authorised by the Prudential Regulation Authority and regulated by the Financial Conduct Authority and the Prudential Regulation Authority under Registration Number 119278.',
            lloydsUDTLeasing: 'Lloyds UDT Leasing Limited, Registered Office: 25 Gresham Street, London EC2V 7HN. Registered in England & Wales no. 665240.',
        },
        lloydsBankAssetFinance: 'Lloyds Bank Asset Finance, part of Lloyds Banking Group, is a member of the Finance & Leasing Association (FLA) and complies with the FLA Business Code of Practice. Lloyds Banking Group is a member of the Lending Standards Board (LSB) and complies with the LSB Standards of Lending Practice for Business Customers (Asset Finance). Further information is available from the FLA at www.fla.org.uk and from the LSB at www.lendingstandardsboard.org.uk.',
        financialOmbudsman: 'We are covered by the Financial Ombudsman Service (FOS). Please note that due to FOS eligibility criteria not all business customers will be covered.',
        creditApproval: 'The provision of credit or leasing services by us is subject to you meeting our credit approval. Please ensure that you only apply for credit or leasing services that you can comfortably afford.',
    },
    errorMessages: [
        {
            key: DOC_ERROR_TYPE.CORRUPT_IMAGE,
            heading: 'This photo is too unclear, please try again',
            supportiveText: 'Make sure the image of your face is clear and the writing on your ID is easy to read',
        },
        {
            key: DOC_ERROR_TYPE.MITEK_ERROR_CORRUPT_IMAGE,
            heading: 'This photo is too unclear, please try again',
            supportiveText: 'Make sure the image of your face is clear and the writing on your ID is easy to read',
        },
        {
            key: DOC_ERROR_TYPE.FOUR_CORNER,
            heading: 'This photo is cropped, please try again',
            supportiveText: 'Make sure all four corners of your ID are in the white box.',
        },
        {
            key: DOC_ERROR_TYPE.MITEK_ERROR_FOUR_CORNER,
            heading: 'This photo is cropped, please try again',
            supportiveText: 'Make sure all four corners of your ID are in the white box.',
        },
        {
            key: DOC_ERROR_TYPE.TOO_DARK,
            heading: 'This photo is too dark, please try again',
            supportiveText: 'Make sure you take the photo in a well-lit area.',
        },
        {
            key: DOC_ERROR_TYPE.MITEK_ERROR_TOO_DARK,
            heading: 'This photo is too dark, please try again',
            supportiveText: 'Make sure you take the photo in a well-lit area.',
        },
        {
            key: DOC_ERROR_TYPE.FOCUS,
            heading: 'This photo is too blurry, please try again',
            supportiveText: 'Make sure the image of your face is clear and the writing on your ID is easy to read.',
        },
        {
            key: DOC_ERROR_TYPE.MITEK_ERROR_FOCUS,
            heading: 'This photo is too blurry, please try again',
            supportiveText: 'Make sure the image of your face is clear and the writing on your ID is easy to read.',
        },
        {
            key: DOC_ERROR_TYPE.GLARE,
            heading: "There's too much glare, please try again",
            supportiveText: 'Make sure there is no light reflecting off your ID. You might need to move to a slightly darker place.',
        },
        {
            key: DOC_ERROR_TYPE.MITEK_ERROR_GLARE,
            heading: "There's too much glare, please try again",
            supportiveText: 'Make sure there is no light reflecting off your ID. You might need to move to a slightly darker place.',
        },
        {
            key: DOC_ERROR_TYPE.MIN_PADDING,
            heading: 'The camera was too close, please try again',
            supportiveText: 'Hold the camera further away from your ID, making sure your ID sits just inside the white box.',
        },
        {
            key: DOC_ERROR_TYPE.MITEK_ERROR_MIN_PADDING,
            heading: 'The camera was too close, please try again',
            supportiveText: 'Hold the camera further away from your ID, making sure your ID sits just inside the white box.',
        },
        {
            key: DOC_ERROR_TYPE.TOO_CLOSE,
            heading: 'The camera was too close, please try again',
            supportiveText: 'Hold the camera further away from your ID, making sure your ID sits just inside the white box.',
        },
        {
            key: DOC_ERROR_TYPE.MITEK_ERROR_TOO_CLOSE,
            heading: 'The camera was too close, please try again',
            supportiveText: 'Hold the camera further away from your ID, making sure your ID sits just inside the white box.',
        },
        {
            key: DOC_ERROR_TYPE.IMAGE_SMALLER_THAN_MIN_SIZE,
            heading: 'The camera was too far away, please try again',
            supportiveText: 'Hold the camera closer to your ID, making sure your ID sits just inside the white box.',
        },
        {
            key: DOC_ERROR_TYPE.MITEK_ERROR_IMAGE_SMALLER_THAN_MIN_SIZE,
            heading: 'The camera was too far away, please try again',
            supportiveText: 'Hold the camera closer to your ID, making sure your ID sits just inside the white box.',
        },
        {
            key: DOC_ERROR_TYPE.HORIZONTAL_FILL,
            heading: 'The camera was too far away, please try again',
            supportiveText: 'Hold the camera closer to your ID, making sure your ID sits just inside the white box.',
        },
        {
            key: DOC_ERROR_TYPE.MITEK_ERROR_HORIZONTAL_FILL,
            heading: 'The camera was too far away, please try again',
            supportiveText: 'Hold the camera closer to your ID, making sure your ID sits just inside the white box.',
        },
        {
            key: DOC_ERROR_TYPE.TOO_FAR,
            heading: 'The camera was too far away, please try again',
            supportiveText: 'Hold the camera closer to your ID, making sure your ID sits just inside the white box.',
        },
        {
            key: DOC_ERROR_TYPE.MITEK_ERROR_TOO_FAR,
            heading: 'The camera was too far away, please try again',
            supportiveText: 'Hold the camera closer to your ID, making sure your ID sits just inside the white box.',
        },
        {
            key: DOC_ERROR_TYPE.SKEW_ANGLE,
            heading: 'This photo is on too much of an angle, please try again',
            supportiveText: "Hold the camera straight above your ID, making sure it's not at an angle.",
        },
        {
            key: DOC_ERROR_TYPE.MITEK_ERROR_SKEW_ANGLE,
            heading: 'This photo is on too much of an angle, please try again',
            supportiveText: "Hold the camera straight above your ID, making sure it's not at an angle.",
        },
        {
            key: DOC_ERROR_TYPE.LOW_CONTRAST,
            heading: 'This photo is too light, please try again',
            supportiveText: 'Place your ID on a darker background to improve the contrast.',
        },
        {
            key: DOC_ERROR_TYPE.MITEK_ERROR_LOW_CONTRAST,
            heading: 'This photo is too light, please try again',
            supportiveText: 'Place your ID on a darker background to improve the contrast.',
        },
        {
            key: DOC_ERROR_TYPE.BUSY_BACKGROUND,
            heading: "The background isn't clear enough, please try again",
            supportiveText: 'Place your ID on a plain background.',
        },
        {
            key: DOC_ERROR_TYPE.MITEK_ERROR_BUSY_BACKGROUND,
            heading: "The background isn't clear enough, please try again",
            supportiveText: 'Place your ID on a plain background.',
        },
        {
            key: DOC_ERROR_TYPE.MRZ_MISSING,
            heading: 'The details on your ID are unclear, please try again',
            supportiveText: 'Make sure the image of your face is clear and the writing on your ID is easy to read.',
        },
        {
            key: DOC_ERROR_TYPE.MITEK_ERROR_MRZ_MISSING,
            heading: 'The details on your ID are unclear, please try again',
            supportiveText: 'Make sure the image of your face is clear and the writing on your ID is easy to read.',
        },
        {
            key: DOC_ERROR_TYPE.PERPENDICULAR_DOCUMENT,
            heading: 'Your ID is the wrong way round, please try again',
            supportiveText: "Rotate your ID so it's horizontal, not vertical.",
        },
        {
            key: DOC_ERROR_TYPE.MITEK_ERROR_PERPENDICULAR_DOCUMENT,
            heading: 'Your ID is the wrong way round, please try again',
            supportiveText: "Rotate your ID so it's horizontal, not vertical.",
        },
        {
            key: DOC_ERROR_TYPE.NOT_CENTRED,
            heading: "Your ID isn't centred, please try again",
            supportiveText: 'Place your ID in the middle of the white box.',
        },
        {
            key: DOC_ERROR_TYPE.MITEK_ERROR_NOT_CENTRED,
            heading: "Your ID isn't centred, please try again",
            supportiveText: 'Place your ID in the middle of the white box.',
        },
    ],
    selfieErrorMessages: [
        {
            key: SELFIE_ERROR_TYPE.MISNAP_HEAD_OUTSIDE,
            heading: 'Your face is outside the frame, please try again',
            supportiveText: 'Make sure your face is inside the oval frame.',
        },
        {
            key: SELFIE_ERROR_TYPE.MITEK_ERROR_MISNAP_HEAD_OUTSIDE,
            heading: 'Your face is outside the frame, please try again',
            supportiveText: 'Make sure your face is inside the oval frame.',
        },
        {
            key: SELFIE_ERROR_TYPE.MISNAP_HEAD_SKEWED,
            heading: 'Your face was on an angle, please try again',
            supportiveText: "Make sure your face is upright and you're looking straight ahead",
        },
        {
            key: SELFIE_ERROR_TYPE.MITEK_ERROR_MISNAP_HEAD_SKEWED,
            heading: 'Your face was on an angle, please try again',
            supportiveText: "Make sure your face is upright and you're looking straight ahead",
        },
        {
            key: SELFIE_ERROR_TYPE.MISNAP_AXIS_ANGLE,
            heading: 'The camera was on an angle, please try again',
            supportiveText: 'Hold your camera upright and look straight ahead',
        },
        {
            key: SELFIE_ERROR_TYPE.MITEK_ERROR_MISNAP_AXIS_ANGLE,
            heading: 'The camera was on an angle, please try again',
            supportiveText: 'Hold your camera upright and look straight ahead',
        },
        {
            key: SELFIE_ERROR_TYPE.MISNAP_HEAD_TOO_CLOSE,
            heading: 'The camera was too close, please try again',
            supportiveText: 'Hold the camera further away, making sure your face sits just inside the oval frame.',
        },
        {
            key: SELFIE_ERROR_TYPE.MITEK_ERROR_MISNAP_HEAD_TOO_CLOSE,
            heading: 'The camera was too close, please try again',
            supportiveText: 'Hold the camera further away, making sure your face sits just inside the oval frame.',
        },
        {
            key: SELFIE_ERROR_TYPE.MISNAP_HEAD_TOO_FAR,
            heading: 'The camera was too far away, please try again',
            supportiveText: 'Hold the camera closer, making sure your face sits just inside the oval frame.',
        },
        {
            key: SELFIE_ERROR_TYPE.MITEK_ERROR_MISNAP_HEAD_TOO_FAR,
            heading: 'The camera was too far away, please try again',
            supportiveText: 'Hold the camera closer, making sure your face sits just inside the oval frame.',
        },
        {
            key: SELFIE_ERROR_TYPE.MISNAP_STAY_STILL,
            heading: 'You were moving too much, please try again',
            supportiveText: 'Make sure you hold still when you take the photo.',
        },
        {
            key: SELFIE_ERROR_TYPE.MITEK_ERROR_MISNAP_STAY_STILL,
            heading: 'You were moving too much, please try again',
            supportiveText: 'Make sure you hold still when you take the photo.',
        },
        {
            key: SELFIE_ERROR_TYPE.MISNAP_READY_POSE,
            heading: 'You were moving too much, please try again',
            supportiveText: 'Make sure you hold still when you take the photo.',
        },
        {
            key: SELFIE_ERROR_TYPE.MITEK_ERROR_MISNAP_READY_POSE,
            heading: 'You were moving too much, please try again',
            supportiveText: 'Make sure you hold still when you take the photo.',
        },
        {
            key: SELFIE_ERROR_TYPE.MISNAP_STOP_SMILING,
            heading: 'You were smiling too much, please try again',
            supportiveText: "Make sure you don't smile when you take the photo.",
        },
        {
            key: SELFIE_ERROR_TYPE.MITEK_ERROR_MISNAP_STOP_SMILING,
            heading: 'You were smiling too much, please try again',
            supportiveText: "Make sure you don't smile when you take the photo.",
        },
        {
            key: SELFIE_ERROR_TYPE.MISNAP_SMILE,
            heading: 'You need to smile for the photo, please try again',
            supportiveText: 'Make sure you hold a smile when you take the photo.',
        },
        {
            key: SELFIE_ERROR_TYPE.MITEK_ERROR_MISNAP_SMILE,
            heading: 'You need to smile for the photo, please try again',
            supportiveText: 'Make sure you hold a smile when you take the photo.',
        },
        {
            key: SELFIE_ERROR_TYPE.NO_FACE_FOUND,
            heading: "Your face isn't in the photo, please try again",
            supportiveText: 'Make sure your whole face sits just inside the oval frame.',
        },
        {
            key: SELFIE_ERROR_TYPE.MITEK_ERROR_NO_FACE_FOUND,
            heading: "Your face isn't in the photo, please try again",
            supportiveText: 'Make sure your whole face sits just inside the oval frame.',
        },
        {
            key: SELFIE_ERROR_TYPE.MITEK_ERROR_GLARE,
            heading: "There's too much glare, please try again",
            supportiveText: "Make sure there's no light reflecting off your face. You might need to move to a slightly darker place.",
        },
        {
            key: SELFIE_ERROR_TYPE.MITEK_ERROR_MITEK_ERROR_GLARE,
            heading: "There's too much glare, please try again",
            supportiveText: "Make sure there's no light reflecting off your face. You might need to move to a slightly darker place.",
        },
        {
            key: SELFIE_ERROR_TYPE.TOO_DARK,
            heading: 'This photo is too dark, please try again',
            supportiveText: 'Make sure you take the photo in a well-lit area.',
        },
        {
            key: SELFIE_ERROR_TYPE.MITEK_ERROR_TOO_DARK,
            heading: 'This photo is too dark, please try again',
            supportiveText: 'Make sure you take the photo in a well-lit area.',
        },
        {
            key: SELFIE_ERROR_TYPE.MITEK_ERROR_FOCUS,
            heading: 'This photo is too blurry, please try again',
            supportiveText: "Make sure your face is in focus and the photo isn't blurry.",
        },
        {
            key: SELFIE_ERROR_TYPE.MITEK_ERROR_MITEK_ERROR_FOCUS,
            heading: 'This photo is too blurry, please try again',
            supportiveText: "Make sure your face is in focus and the photo isn't blurry.",
        },
        {
            key: SELFIE_ERROR_TYPE.MITEK_ERROR_COMMON,
            heading: 'This photo is too unclear, please try again',
            supportiveText: 'Make sure your face is in focus and you hold still.',
        },
    ],
};
//# sourceMappingURL=index.js.map